<template>
<div class="pages">
  <div class="container">
    <h1>監修紹介</h1>

    <div class="supervisor">
      <div class="thumb">
        <img src="/learn/images/thumb_mitsuo_ueno.png" alt="上野　光夫">
      </div>
      <div class="text">
        <div class="supervisor-name"><h2><ruby>上野<rt>うえの</rt></ruby>　<ruby>光夫<rt>みつお</rt></ruby></h2></div>
        <p>中小企業診断士・資金調達コーディネーター®。>昭和３７年鹿児島市生まれ。九州大学を卒業後、日本政策金融公庫（旧国民生活金融公庫）に２６年間勤務し、主に中小企業への融資審査の業務に携わる。３万社の中小企業への融資と、５千名の起業家への創業融資を担当した。融資総額は2,000億円にのぼる。平成２３年４月にコンサルタントとして独立。起業支援コンサルティング、資金調達サポートを行うほか、研修、講演、執筆など幅広く活動している。リクルート社『アントレ』などメディア登場実績多数。日本最大の起業家支援プラットフォーム「ＤＲＥＡＭ　ＧＡＴＥ」において、アドバイザーランキング「資金調達部門」で３年連続して第１位に輝く。</p>
        <div class="supervisor-link">
          <a href="https://mmconsulting.jp/">https://mmconsulting.jp/</a>
        </div>
      </div>
    </div>

    <h2>主な著作</h2>
    <ul>
      <li>事業計画書は1枚にまとめなさい―――公庫の元融資課長が教える開業資金らくらく攻略法（2016年、ダイヤモンド社）</li>
      <li>起業は１冊のノートから始めなさい（2013年、ダイヤモンド社）</li>
      <li>絶対に後悔しない! 45歳からの起業の心得 (2016年、アスカビジネス)</li>
    </ul>
    <p class="text-right"><a href="https://www.amazon.co.jp/%E4%B8%8A%E9%87%8E-%E5%85%89%E5%A4%AB/e/B00BHAGHSG/ref=dp_byline_cont_book_1" target="_blank">Amazonで著作一覧を見る</a></p>
    <h2>登壇・セミナー</h2>
    <ul>
      <li>横浜銀行・日本政策金融公庫共催創業支援セミナー「成功する起業に向けて」</li>
      <li>城南信用金庫・日本政策金融公庫共催創業支援スクール「起業時の資金調達」</li>
      <li>中野区産業振興センター経営力アップ講座「金融機関との上手い付き合い方」</li>
      <li>奈良県三郷町セミナー「起業は１冊のノートから始めなさい」</li>
      <li>東京都豊島区・日本政策金融公庫共催創業支援フォーラム「パネルディスカッション」</li>
    </ul>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="scss" src="@/assets/scss/layouts/_pages.scss"></style>
<script>
export default {
  data: function() {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function() {}
}
</script>
